<fgb-banner [pageTitle]="'contact.us.page.title' | translate" />
<fgb-page-header [pageTitle]="'contact.us.page.title'" [showBalance]="false" [backButtonLink]="'/'"/>
<fgbcl-contact-us></fgbcl-contact-us>
